<template>
  <div>
    <div id="auth-view-background" class="secondary lighten-1" style="position:absolute;height:100%;width:100%"></div>
    <v-container fluid>
      <v-row>
        <v-col align="center">
          <v-img contain height="128px" :src="require('@/assets/logo_soda_default.png')" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row align="center" justify="center">
            <v-card tile class="pa-4" width="440">
              <SignUpView v-if="state === 'signUp'" :email="email" />
              <SignUpConfirmView v-if="state === 'signUpConfirm'" :email="email" />
              <SignInView v-if="state === 'signIn'" :email="email" />
              <PasswordResetView v-if="state === 'passwordReset'" :email="email" />
              <div v-if="state === 'signUp'">
                <p class="mt-6 caption">
                  <a href="" v-bind:class="toggle" @click="toggle">Bei existierendem SODA-Konto anmelden.</a>
                </p>
                <p class="mt-6 caption">
                  <a href="" v-bind:class="showConfirmView" @click="showConfirmView">Registrierungscode eingeben.</a>
                </p>
              </div>
              <div v-if="state === 'signIn'">
                <p class="mt-4 caption grey--text"><center>Neu bei SODA?</center></p>
                <v-btn outlined block @click="toggle" small color="grey">Zur Registrierung</v-btn>
              </div>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { getUser } from "./auth.js";

import SignUpView from "./SignUpView";
import SignUpConfirmView from "./SignUpConfirmView";
import SignInView from "./SignInView";
import PasswordResetView from "./PasswordResetView";

export default {
  name: "AuthView",
  components: {
    SignUpView,
    SignUpConfirmView,
    SignInView,
    PasswordResetView,
  },
  beforeRouteEnter: (to, from, next) => {
    // will read parameter "authViewInitialState" from localStorage.
    // (We do not use route params because those are supposed to be stateless,
    // and we do not want to change route upon state change.)
    //
    // to show signUp, do localStorage.setItem('authViewInitialState', 'signUp') before pushing the route /auth
    //
    var initialState = localStorage.getItem("authViewInitialState");
    if (initialState && ["signIn", "signUp", "signUpConfirm", "passwordReset"].includes(initialState)) {
      localStorage.removeItem("authViewInitialState");
      next((vm) => {
        vm.state = initialState;
      });
    } else {
      next();
    }
  },
  async mounted() {
    this.$root.$on("email", (email) => {
      this.email = email;
    });
    const user = await getUser();
    if (user) {
      this.$router.push({ path: "/app" });
    }
    AmplifyEventBus.$on("authState", async (state) => {
      //console.log("AmplifyEventBus.$on('authState',", state, ")")
      const pushPathes = {
        signedOut: () => {
          this.state = "signIn";
        },
        signUp: () => {
          this.state = "signUp";
        },
        confirmSignUp: () => {
          this.state = "signUpConfirm";
        },
        signIn: () => {
          this.state = "signIn";
        },
        signedIn: () => {
          this.forward();
        },
        passwordReset: () => {
          this.state = "passwordReset";
        },
      };
      if (typeof pushPathes[state] === "function") {
        pushPathes[state]();
      }
    });
  },
  methods: {
    forward() {
      if (localStorage.getItem("payment_intent_product_id") || (this.$route.params && this.$route.params.finished)) {
        this.$router.push({ path: "/purchase", params: this.$route.params });
      } else {
        this.$router.push({ path: "/app/account" });
      }
    },
    toggle(e) {
      e.preventDefault();
      this.state === "signUp" ? (this.state = "signIn") : (this.state = "signUp");
    },
    showConfirmView(e) {
      e.preventDefault();
      this.state = "signUpConfirm";
    },
  },
  data: function() {
    return {
      state: "signIn",
      email: null,
    };
  },
};
</script>

<style lang="scss" scoped></style>
